import ToastContainer from './ToastContainer.vue'

const ToastPlugin = {
  install(Vue) {
    let containerInstance = null
    let toastId = 0

    function ensureContainer() {
      if (containerInstance) return containerInstance
      const ToastContainerCtor = Vue.extend(ToastContainer)
      const el = document.createElement('div')
      document.body.appendChild(el)
      containerInstance = new ToastContainerCtor().$mount(el)
      return containerInstance
    }

    Vue.prototype.$toast = {
      show({ icon, title, description, severity = 'default', variant = 'regular', duration, action } = {}) {
        const container = ensureContainer()
        const id = ++toastId
        container.addToast({ id, icon, title, description, severity, variant, duration, action })
        return id
      },
      close(id) {
        if (containerInstance) containerInstance.removeToast(id)
      },
      closeAll() {
        if (containerInstance) containerInstance.clearAll()
      },
      has(id) {
        return containerInstance ? containerInstance.hasToast(id) : false
      }
    }
  }
}

export default ToastPlugin
